import { TemplateRef } from '@angular/core';
import { TranslatedString } from 'models/translated-string';

export interface CsSelectOptionInterface {
  deselect(): void;
  getLabel(): TranslatedString;
  getAbbreviatedLabel(): TranslatedString;
  getIcon(): string;
  getContentTemplate(): TemplateRef<any>;
  getValue(): any;
  isSelected(): boolean;
  isDisabled(): boolean;
  handleOptionClick(): void;
}

export class CsSelectOptionBase implements CsSelectOptionInterface {
  isDisabled(): boolean {
    throw new Error("Method not implemented.");
  }
  deselect(): void {
    throw new Error("Method not implemented.");
  }

  getLabel(): TranslatedString {
    throw new Error("Method not implemented.");
  }

  getAbbreviatedLabel(): TranslatedString {
    return this.getLabel();
  }

  getIcon(): string {
    throw new Error("Method not implemented.");
  }

  getContentTemplate(): TemplateRef<any> {
    return undefined;
  }

  getValue(): any {
    throw new Error("Method not implemented.");
  }

  handleOptionClick(): void {
    throw new Error("Method not implemented.");
  }

  isSelected(): boolean {
    throw new Error("Method not implemented.");
  }
}
